import { render, staticRenderFns } from "./coperbaseaktarim.vue?vue&type=template&id=2fdf2896&"
import script from "./coperbaseaktarim.vue?vue&type=script&lang=js&"
export * from "./coperbaseaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports